var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('div',{staticClass:"blog"},[_c('div',{staticClass:"container mt-2 mt-md-4 mb-2 mb-md-4"},[_c('h1',{staticClass:"h1 text-center"},[_vm._v(_vm._s(_vm.document.title))])]),_vm._v(" "),_c('blog-list',{attrs:{"type":_vm.document.list_type,"show-search":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }